import * as React from 'react';
import ContractPdf from './contract/ContractPdf';
import Typography from '../../../layouts/theme-onboarding/Typography';
import Grid from '@mui/material/Grid';
import { makeStyles } from '@mui/styles';
import Color from '../../../layouts/Color';

const useStyles = makeStyles(function (theme) {
  return {
    gridContainer: {
      [theme.breakpoints.up("xl")]: {
        paddingLeft: ' 200px',
        paddingRight: '200px',
        marginTop: "20px"
      },
    },
  };
});

const info = { textAlign: 'left' };

export default function SignContract(props) {
  const classes = useStyles();

  return (
      <Grid container spacing={3} className={classes.gridContainer}>
        <Grid item xs={12} sx={info}> 
          <Typography variant="h4" color={Color.Main}> Below is the terms of contract between customer and Apollo: </Typography> 
        </Grid>
        <ContractPdf step1Result={props.step1Result} onUpdateStep2Data={props.onUpdateStep2Data}></ContractPdf>
      </Grid>
  );
}